import { Input, Button } from 'antd';
import { SearchOutlined, PlusOutlined } from '@ant-design/icons';
import styles from './index.module.scss';

const ContentHeader = (props) => {
    const { title, total, searchKeyword, onSearch, batchMode, onBatchMode } = props;

    return (
        <div className={styles.ContentHeader}>
            <div className={styles.left}>
                <span className={styles.title}>{title}</span>
                <span className={styles.total}>共{total || 0}个素材</span>
            </div>
            <div className={styles.right}>
                <Input
                    className={styles.searchInput}
                    placeholder="搜索内容"
                    prefix={<SearchOutlined style={{ color: '#BFBFBF' }} />}
                    value={searchKeyword}
                    onChange={e => onSearch(e.target.value)}
                    allowClear
                />
                <Button
                    icon={<PlusOutlined />}
                    onClick={() => onBatchMode(!batchMode)}
                >
                    批量操作
                </Button>
                <Button type="primary">
                    上传参考图
                </Button>
            </div>
        </div>
    );
};

export default ContentHeader;